import React from 'react';

import { Mp3KbpPlayerCommonColors } from 'stylesheet';

import { ProgressSlider, ProgressSliderContainer } from './CircularProgress.style';

const VIEW_BOX_SIZE = 100;
const VIEW_BOX_CENTER = VIEW_BOX_SIZE / 2;
const CIRCLE_RADIUS = 0.4565 * VIEW_BOX_SIZE; // adjusted to fit the BAM logo size
const CIRCLE_STROKE_WIDTH = 0.01 * VIEW_BOX_SIZE;

interface Props {
  timerDurationInMs: number;
  isPlaying: boolean;
  delayInMilliseconds: number;
  mp3KbpPlayerColors: Mp3KbpPlayerCommonColors;
}

const CircularProgress: React.FC<Props> = ({
  timerDurationInMs,
  isPlaying,
  delayInMilliseconds,
  mp3KbpPlayerColors,
}) => {
  return (
    <ProgressSliderContainer viewBox={`0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}`}>
      <ProgressSlider
        cx={VIEW_BOX_CENTER}
        cy={VIEW_BOX_CENTER}
        r={CIRCLE_RADIUS}
        fill={mp3KbpPlayerColors.timerCircularProgressBackground}
        stroke={mp3KbpPlayerColors.timerCircularProgress}
        strokeWidth={CIRCLE_STROKE_WIDTH}
        transform={`rotate(-90, ${VIEW_BOX_CENTER}, ${VIEW_BOX_CENTER})`}
        timerDurationInMs={timerDurationInMs}
        isPlaying={isPlaying}
        delayInMilliseconds={delayInMilliseconds}
        circlePerimeter={2 * Math.PI * CIRCLE_RADIUS}
      />
    </ProgressSliderContainer>
  );
};

export default CircularProgress;
